// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container__QIuih","canvas":"Hero_canvas__KPZEH","content":"Hero_content__A50ax"};